import { AnalysisStatus } from "../../lib/enums";

export const isInfoClassification = (classification?: string | number) =>
  classification === AnalysisStatus.PROCESSING ||
  classification === AnalysisStatus.REANALYZING ||
  classification === "error";
